import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { setInitialStoreState } from '../../../../../common/utils';
import { DemurrageDetentionListFacade } from './demurrage-detention-list.facade';

@Injectable({
  providedIn: 'root',
})
export class DemurrageDetentionListGuard  {
  constructor(private demurrageAndDetentionFacade: DemurrageDetentionListFacade, private router: Router) {}

  canDeactivate(): boolean {
    return setInitialStoreState(this.demurrageAndDetentionFacade);
  }
}
